import prodConfig from './prod';
import devConfig from './dev';

export interface Config {
  env: string;
  apiServerBase: string;
  useMockData: boolean;
}

export default function getConfig(): Config {
  if (process.env.REACT_APP_ENV === 'production') {
    return prodConfig;
  }
  return devConfig;
}
